<footer class="site_footer">
  <div class="conta_iner">
    <div class="inner">
      <div class="single_col">
        <a class="site_logo" routerLink="/">
          <figure><img 
            [src]="assetsConst.logo" 
            alt="Logo" 
            loading="lazy"
            width="65" height="50"  
          /></figure>
        </a>
        <p style="text-wrap: balance;">
          {{'Welcometoluxurycurationwherethebestexperiencesigniteexceptionalliving' | translate}}
        </p>
        <h2>{{ 'FollowUs' | translate }}</h2>
        <ul class="social_links">
          <li>
            <a target="_blank" href="https://www.instagram.com/xplora.luxe/?igsh=bnRpdHQ3aTc2ZDRs"><img src="{{ assetsConst.instagram_icon }}" alt="Icon" /></a>
          </li>
          <li>
            <a target="_blank" href="https://www.facebook.com/xploraluxe?mibextid=LQQJ4d"><img src="{{ assetsConst.facebook_icon }}" alt="Icon" /></a>
          </li>
          <li>
            <a target="_blank" href="https://www.linkedin.com/company/xplora-luxe/"><img src="{{ assetsConst.linkedin_icon }}" alt="Icon" /></a>
          </li>
          <li>
            <!-- <a target="_blank" href="https://www.youtube.com/@xploraluxe-x3w"><img src="{{ assetsConst.youtube_icon }}" alt="Icon" /></a> -->
            <a target="_blank" href="https://www.youtube.com/@XploraLuxe/featured"><img src="{{ assetsConst.youtube_icon }}" alt="Icon" /></a>
          </li>

        </ul>
        <h2>{{ 'Paymentchannels' | translate }}</h2>
        <ul class="accepted-cards">
          <li><img src="{{ assetsConst.visa }}" alt="Icon" /></li>
          <li><img src="{{ assetsConst.master_icon }}" alt="Icon" /></li>
          <li><img src="{{ assetsConst.union_icon }}" alt="Icon" /></li>
          <li><img src="{{ assetsConst.american_icon }}" alt="Icon" /></li>
          <li><img src="{{ assetsConst.googlepay }}" alt="Icon" style="width: 60px; height:36px; padding:5px" /></li>
          <li><img src="{{ assetsConst.applepay }}" alt="Icon"  style="width: 60px; height:36px; padding:5px"/></li>
          <li><img src="{{ assetsConst.samsungpay }}" alt="Icon"  style="width: 60px; height:36px; padding:5px"/></li>
        </ul>

      </div>
      <div class="single_col">
        <h2>{{ 'QuickLinks' | translate }}</h2>
        <ul class="footer_links">
          <li><a routerLink="/support/about-us"  aria-label="About Us">{{'AboutUs' | translate}}</a></li>
          <li><a (click)="openMemberStep1Modal()" aria-label="Become a Partner">{{'BecomeaPartner' | translate}}</a></li>
          <li>
            <a routerLink="/ourStories" aria-label="Our Strories">{{ 'OurStories' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="'/contact-us'" aria-label="Contact Us">{{ 'Connectwithus' | translate }}</a>
          </li>
        </ul>
      </div>

      <div class="single_col">
        <h2>{{'Additional Offerings'|translate}}</h2>
        <ul class="footer_links">
          @for (item of cmsContent | slice:8:12; track $index) {
            <li>
              <a [routerLink]="item.cmsRoute" aria-label=item.cmsTitle>
                {{ item.cmsTitle | translate }}
              </a>
            </li>
            }
        </ul>
      </div>

      <div class="single_col">
        <h2>{{ 'Information' | translate }}</h2>
        <ul class="footer_links">
          @for (item of cmsContent | slice:0:8; track $index) {
          <li>
            <a [routerLink]="item.cmsRoute">
              {{ item.cmsTitle | translate }}
            </a>
          </li>
          }
        </ul>
      </div>

      <div class="single_col">
        <div class="address-box">
          <h3>{{'Address' | translate}}</h3>
          <p>{{'Address' | translate}}:{{'BuildingA1DubaiDigitalParkDubaiSiliconOasisDubaiUnitedArabEmirates' | translate}}</p>
          <a href="mailto:support@xploraluxe.com"><mat-icon> email</mat-icon> support&#64;xploraluxe.com</a>
          <a href="tel:+971 545888785"><mat-icon> call</mat-icon>+971 545888785</a>
        </div>

      </div>
    </div>
    <div class="copywrite">
      <p>
        {{ 'Copyrights' | translate }} &copy; {{ currentYear }}, {{'AllRightReservedByXploraLuxe' | translate}}
      </p>
    </div>
  </div>
</footer>

<a target="_blank" class="floating_btn" [href]="whatsappLink">
  <i class="fa fa-whatsapp"></i>
</a>
<span class="floating_goTop" (click)="scrollToTop()" [ngClass]="{ 'show': showButton }">
  <mat-icon>keyboard_arrow_up</mat-icon>
</span>
